__turbopack_context__.v({
  "content": "mochi-radio-item-module-scss-module__Y3S5Nq__content",
  "mochi-radio-item-group": "mochi-radio-item-module-scss-module__Y3S5Nq__mochi-radio-item-group",
  "radio-item": "mochi-radio-item-module-scss-module__Y3S5Nq__radio-item",
  "text": "mochi-radio-item-module-scss-module__Y3S5Nq__text",
  "top": "mochi-radio-item-module-scss-module__Y3S5Nq__top",
});
